import React from "react";
import { motion } from "framer-motion";
import MarketingShell from "@/components/MarketingShell";
import SubscribeForm from "@/components/SubscribeForm";

export default function Notes() {
  return (
    <MarketingShell active="/notes">
      <motion.section initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
        <p className="text-[10px] uppercase tracking-[0.32em] mb-3" style={{ color: "#F2D589" }}>
          Notes
        </p>
        <h1
          className="leading-[0.95]"
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontWeight: 500,
            fontSize: "clamp(40px, 5.6vw, 84px)",
            textWrap: "balance",
            maxWidth: "18ch",
          }}
        >
          Notes from the <em style={{ color: "#F2D589" }}>piano bench</em>.
        </h1>
        <p className="mt-5 max-w-[44rem] text-base sm:text-lg leading-relaxed" style={{ color: "rgba(245,239,227,0.78)" }}>
          A working journal, thoughts on improvisation, Jewish
          modes, the practice room, the road, and the strange beautiful
          dissonances I keep finding under my fingers.
        </p>
      </motion.section>

      <section
        className="mt-12 rounded-2xl border p-8 sm:p-12 backdrop-blur-md text-center"
        style={{ borderColor: "rgba(232,196,138,0.25)", backgroundColor: "rgba(8,4,25,0.45)" }}
        data-testid="notes-coming-soon"
      >
        <p className="text-[10px] uppercase tracking-[0.32em] mb-3" style={{ color: "#F2D589" }}>
          First entry brewing
        </p>
        <p
          className="text-2xl sm:text-4xl mb-4"
          style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: "italic" }}
        >
          The first notes land soon.
        </p>
        <p className="max-w-[40rem] mx-auto text-base sm:text-lg leading-relaxed mb-6" style={{ color: "rgba(245,239,227,0.78)" }}>
          The journal is in the kiln, opening up in a few weeks.
          Subscribe to get each entry the moment it drops, alongside the
          rest of Dan&apos;s behind-the-scenes dispatches.
        </p>
        <div className="max-w-[34rem] mx-auto text-left">
          <SubscribeForm testIdPrefix="notes-subscribe" buttonLabel="Notify me" />
        </div>
      </section>
    </MarketingShell>
  );
}
